import { createSelector } from '@reduxjs/toolkit';
import { selectWithDeposit } from 'shared/selectors/jsonQuery';

export const selectWithDepositFilter = createSelector(selectWithDeposit, value => ({
  label: 'Без залога',
  value,
}));
